// Text for the world 'cats': the name on the map and the level titles, per language.
// The ids must be the level ids in levels.ts (npm run validate checks this); other languages must have the same ids as da (tsc).
import { defineWorldStrings } from '../../core/i18n';

export const strings = defineWorldStrings({
  da: {
    name: 'Dovne katte',
    levels: {
      'book-topples': { title: 'Bogen vælter' },
      'wake-the-cat': { title: 'Væk katten' },
      'toy-mouse': { title: 'Legetøjsmusen' },
      'big-or-small': { title: 'Stor eller lille' },
      'gap-in-the-row': { title: 'Hullet i rækken' },
      'mouse-starts': { title: 'Musen starter' },
      'cat-jumps': { title: 'Katten hopper' },
      'right-way': { title: 'Den rigtige vej' },
      'stairs': { title: 'Trappen' },
      'mouse-and-book': { title: 'Mus og bog' },
      'far-away': { title: 'Langt væk' },
      'two-cats': { title: 'To katte' },
      'off-the-shelf': { title: 'Ned fra hylden' },
      'hop-and-topple': { title: 'Hop og vælt' },
      'master-chain': { title: 'Mesterkæden' },
    },
  },
  en: {
    name: 'Lazy cats',
    levels: {
      'book-topples': { title: 'The book topples' },
      'wake-the-cat': { title: 'Wake the cat' },
      'toy-mouse': { title: 'The toy mouse' },
      'big-or-small': { title: 'Big or small' },
      'gap-in-the-row': { title: 'Gap in the row' },
      'mouse-starts': { title: 'The mouse goes first' },
      'cat-jumps': { title: 'The cat jumps' },
      'right-way': { title: 'The right way' },
      'stairs': { title: 'The stairs' },
      'mouse-and-book': { title: 'Mouse and book' },
      'far-away': { title: 'Far away' },
      'two-cats': { title: 'Two cats' },
      'off-the-shelf': { title: 'Off the shelf' },
      'hop-and-topple': { title: 'Hop and topple' },
      'master-chain': { title: 'The master chain' },
    },
  },
});
